import { Epsi } from '../../epsi/manager/Epsi';
import AppWrapper from '../../AppWrapper';
import { APP_TYPE } from '../../constants';
import { ManagerMenu } from '../../manager/managermenu';
import { useSelector } from '../../hooks';

import { Error, ERROR_TYPE } from '../components/Error';

const ManagerEpsiPage = () => {
  const { manager, apps } = useSelector((state) => state.app.config);

  return (
    <>
      {apps?.manager && manager?.modules?.epsi ? (
        <AppWrapper
          appType={APP_TYPE.MANAGER}
          menu={<ManagerMenu />}
        // resource='RelatedApps'
        // action='allow_manager_epsi'
        >
          <Epsi />
        </AppWrapper>
      ) : (
        <Error type={ERROR_TYPE.NOT_FOUND} />
      )}
    </>
  );
};

export default ManagerEpsiPage;
